import React from "react";
import { fmtEt } from "./giveawayUtils";
import { SectionCard } from "./GiveawayUi";

// Read only: every admin action on this giveaway, and every rules version.

const show = (v) => {
  if (v == null || v === "") return "";
  if (typeof v === "string") return v;
  try {
    return JSON.stringify(v);
  } catch {
    return String(v);
  }
};

const readable = (action) => String(action || "").replace(/[_.]/g, " ");

const GiveawayAuditTab = ({ g }) => {
  const audit = Array.isArray(g.audit) ? g.audit : [];
  const versions = Array.isArray(g.versions) ? g.versions : [];

  return (
    <div>
      <SectionCard title="Audit trail" subtitle="Every action taken on this giveaway, newest first.">
        {audit.length === 0 ? (
          <div className="text-sm text-secondary-light">Nothing recorded yet.</div>
        ) : (
          <div className="table-responsive">
            <table className="table bordered-table mb-0">
              <thead>
                <tr>
                  <th>When</th>
                  <th>Admin</th>
                  <th>Action</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {audit.map((a, i) => (
                  <tr key={i}>
                    <td className="text-sm text-nowrap">{fmtEt(a.at, "")}</td>
                    <td className="text-xs">{a.adminId || "System"}</td>
                    <td className="text-sm" style={{ textTransform: "capitalize" }}>
                      {readable(a.action)}
                    </td>
                    <td className="text-xs" style={{ maxWidth: 480, wordBreak: "break-word" }}>
                      {show(a.details)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </SectionCard>

      <SectionCard title="Rules versions" subtitle="Each time the rules changed after people entered.">
        {versions.length === 0 ? (
          <div className="text-sm text-secondary-light">No rule changes recorded.</div>
        ) : (
          <div className="table-responsive">
            <table className="table bordered-table mb-0">
              <thead>
                <tr>
                  <th>When</th>
                  <th>Version</th>
                  <th>Admin</th>
                  <th>Reason</th>
                  <th>What changed</th>
                </tr>
              </thead>
              <tbody>
                {versions.map((v, i) => (
                  <tr key={i}>
                    <td className="text-sm text-nowrap">{fmtEt(v.at, "")}</td>
                    <td className="text-sm fw-semibold">{v.rulesVersion}</td>
                    <td className="text-xs">{v.adminId || ""}</td>
                    <td className="text-sm">{v.reason}</td>
                    <td className="text-xs" style={{ maxWidth: 420, wordBreak: "break-word" }}>
                      {Array.isArray(v.changes) ? v.changes.join(", ") : show(v.changes)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </SectionCard>
    </div>
  );
};

export default GiveawayAuditTab;
